import { connect } from 'react-redux';
import ConfirmRegistration from './ConfirmRegistration';
import { userActions } from '../../redux/actions/userActions';

const mapStateToProps = ({ authentication: { email, success, error } }) => {
  return {
    email: email || localStorage.getItem('confirmEmail'),
    error,
    success
  };
};

const mapDispatchToProps = dispatch => ({
  resendActivation: (email, sourceUrl) =>
    dispatch(userActions.resendActivation(email, sourceUrl))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmRegistration);



// WEBPACK FOOTER //
// ./src/components/confirm/ConfirmRegistrationContainer.js